export type { IMaskInputProps } from './MaskedInput'
export { MaskedInput } from './MaskedInput'
